// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2DOXc","child":"_19HZy","gridRowChild":"_1h7CS","childCard":"_34yGp"};